import {
  DiscoverUs,
  Faces,
  HeroSection,
  NewsLetter,
} from '../../components/AboutUs';
import { Divider } from '../../designComponents';

type Props = {};

const AboutUs = (_props: Props) => {
  return (
    <div>
      <HeroSection />
      <Divider style={{ maxWidth: '1300px', margin: '0 auto' }} />
      <DiscoverUs />
      <Faces />
      <NewsLetter />
    </div>
  );
};

export default AboutUs;
